import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import CookieBanner from './components/legal/CookieBanner';
import ScrollToTop from './components/utils/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import FeaturesPage from './pages/FeaturesPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import PrivacyPage from './pages/legal/PrivacyPage';
import TermsPage from './pages/legal/TermsPage';
import ImpressumPage from './pages/legal/ImpressumPage';
import CookiePolicyPage from './pages/legal/CookiePolicyPage';
import DataDeletionPage from './pages/legal/DataDeletionPage';
import SupportPage from './pages/SupportPage';
import NotFoundPage from './pages/NotFoundPage';

function App() {
  const [cookieConsent, setCookieConsent] = useState(null);

  useEffect(() => {
    const stored = localStorage.getItem('cookieConsent');
    if (stored) {
      setCookieConsent(JSON.parse(stored));
    }
  }, []);

  const handleCookieAccept = (preferences) => {
    localStorage.setItem('cookieConsent', JSON.stringify(preferences));
    setCookieConsent(preferences);
  };

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/features" element={<FeaturesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="/cookie-policy" element={<CookiePolicyPage />} />
          <Route path="/data-deletion" element={<DataDeletionPage />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      {cookieConsent === null && (
        <CookieBanner onAccept={handleCookieAccept} />
      )}
    </>
  );
}

export default App;
